export class TokenLoginPageController {
    /*@ngInject*/
    constructor($rootScope, $state, $scope, modalService, authService, moment, StorageService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.modalService = modalService;
        this.authService = authService;
        this.moment = moment;
        this.StorageService = StorageService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        // params
        this.token = this.$stateParams.t;
        this.action = this.$stateParams.a;
        this.outreachId = this.$stateParams.o ? this.$stateParams.o : null;
        this.candidateId = this.$stateParams.cid ? this.$stateParams.cid : null;
        this.companyId = this.$stateParams.comp ? this.$stateParams.comp : null;
        this.userIdsArray = [];
        this.tokenData = {};
        // flags
        this.loadingFlag = true;
        this.authenticatedFlag = false;
        this.isUserAlreadyLoggedIn = false;
        this._handleUserNavigation();
    }
    _handleUserNavigation() {
        let userDetails = angular.copy(this.StorageService.get('userDetails'));
        //User's session already active
        if (userDetails && this.action != 'Outreach') {
            this.authService.getUserIdByToken(this.token, (data) => {
                if (data.id == userDetails.id) {
                    this.userId = userDetails.id;
                    this.$rootScope.userDetails = this.StorageService.get('userDetails');
                    this.email = this.$rootScope.userDetails.emailId;
                    this.isUserAlreadyLoggedIn = true;
                }
                else {
                    this._logoutAndRedirectUser(false);
                }
                this.loadingFlag = false;
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this._logoutAndRedirectUser(false);
            this.loadingFlag = false;
        }
    }
    _logoutAndRedirectUser(redirectFlag) {
        var rememberMeStatus = angular.copy(this.StorageService.getCookie('rememberme'));
        let userDetails = angular.copy(this.StorageService.get('userDetails'));
        this.StorageService.resetBrowserStorage();
        if (angular.isDefined(rememberMeStatus) && (rememberMeStatus !== null) && (rememberMeStatus === true)) {
            if (angular.isDefined(userDetails) && (userDetails !== null)) {
                this.StorageService.setCookie('logoutemail', userDetails.emailId);
            }
        }
        this.authService.logout((data) => {
            this.StorageService.removeCookie('connect.sid');
            this.StorageService.remove('companyDetails');
            this.StorageService.remove('SelectedHostCompany');
            this.StorageService.remove('userDetails');
            if (redirectFlag) {
                this.$state.go('login', null, { reload: true });
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    successCallback(tokenResponse) {
        if (!this.isUserAlreadyLoggedIn) {
            this.StorageService.removeCookie('logoutemail');
            this._manageCookiesandRememberMe(tokenResponse);
            let userObj = {};
            this.$rootScope.userDetails = userObj;
            console.log('createUserDetailsObject(data) : ' + angular.toJson(this._createUserDetailsObject(tokenResponse)));
            this.StorageService.set('userDetails', this._createUserDetailsObject(tokenResponse), { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
            this.$rootScope.userDetails = this.StorageService.get('userDetails');
        }
        if (this.action === 'Outreach') {
            this.$rootScope.userActive = false; // Remove After converting to angular
            this.$state.go('candidateOutreach', { outreachId: this.outreachId, candidateId: this.candidateId, companyId: this.companyId, tokenId: this.token });
        }
        else {
            this._getTokenPayload((tokenData) => {
                this.tokenData = tokenData;
                this.userIdsArray.push(this.$rootScope.userDetails.id);
                const workflowSteps = {
                    PhoneScreen: 'ps',
                    Interview: 'in'
                };
                if (workflowSteps[this.action]) {
                    this.authenticatedFlag = true;
                    this.$state.go('conference', {
                        sh: this.tokenData.meetingScheduleId,
                        ws: workflowSteps[this.action],
                        mode: this.tokenData.meetingMode
                    });
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    errorCallback(tokenResponse) {
        this.alertsAndNotificationsService.showBannerMessage(tokenResponse.message, 'danger');
    }
    _getTokenPayload(successCallback, errorCallback) {
        this.authService.getTokenPayload(this.token, this.$rootScope.userDetails.id, (data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    /**
     * This method is invoked from login success call.
     * It manages cookis storage and rememberme status
     */
    _manageCookiesandRememberMe(data) {
        this.rememberme = true;
        if (this.rememberme) {
            this.StorageService.setCookie('rememberme', true, { 'expires': new Date(Date.now() + this.$rootScope.refreshtokenvalidity) });
        }
        else {
            this.StorageService.setCookie('rememberme', false, { 'expires': new Date(Date.now() + this.$rootScope.refreshtokenvalidity) });
        }
        this.StorageService.setCookie('refreshtoken', data.refreshToken, { 'expires': new Date(Date.now() + this.$rootScope.refreshtokenvalidity) });
    }
    _createUserDetailsObject(data) {
        let obj = {};
        obj.company = {};
        obj.plan = {};
        obj.id = data.id;
        obj.firstname = data.firstname;
        obj.lastname = data.lastname;
        obj.emailId = data.emailId;
        obj.companyId = data.companyId;
        // obj.accesstoken = data.token;
        obj.company.companyId = data.company.companyId;
        obj.company.companyName = data.company.companyName;
        obj.company.companyType = data.company.companyType;
        obj.company.companyState = data.company.companyState;
        obj.company.companyStateLabel = data.company.companyState == 'SoftHold' ? 'Soft Hold' : data.company.companyState;
        obj.company.message = data.company.message;
        obj.plan.planName = data.planMinDto.planName;
        obj.plan.planType = data.planMinDto.planType;
        obj.plan.startDate = this.moment(data.planMinDto.planStartDate);
        obj.plan.endDate = this.moment(data.planMinDto.planEndDate);
        obj.plan.message = "";
        obj.accountState = data.accountState;
        obj.shouldPopupBeDisplayed = data.shouldPopupBeDisplayed;
        if (!_.isNull(data.roleScreenRef)) {
            obj.roleScreenRef = this._createRoleScreenRefObj(data.roleScreenRef.role);
        }
        else if (!_.isNull(data.role)) {
            obj.roleScreenRef = this._createRoleScreenRefObj(data.role);
        }
        return obj;
    }
    _createRoleScreenRefObj(role) {
        let roleObj = {};
        roleObj.role = {};
        roleObj.role.id = role.id;
        roleObj.role.name = role.name;
        // roleObj.screen = manageScreenListforRoles(roleScreenRef.screen);
        return roleObj;
    }
    actionSaveCallback() {
        if ((this.action == 'PhoneScreen' || this.action == 'Interview') && !this.isUserAlreadyLoggedIn) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-info' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: "This action is a one time action. It will save and log you out. If you wish to continue entering feedback click 'Cancel'. If you are done, click 'Ok'.",
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Ok',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        this._logoutAndRedirectUser(true);
                    }
                    else {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
    }
}
TokenLoginPageController.$inject = ['$rootScope', '$state', '$scope', 'modalService', 'authService', 'moment', 'StorageService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './token-login-page.html';
import * as TEMPLATE from 'raw-loader!./token-login-page.html';
export const TokenLoginPageComponent = {
    selector: 'tokenLoginPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/tokenLogin/token-login-page.html',
        template: TEMPLATE.default,
        controller: TokenLoginPageController
    }
};
//# sourceMappingURL=token-login-page.component.js.map